import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Redirect, useLocation } from "react-router";
import config from "../../config/apiConfig";
import fp from "../../config/filterPref";
import { Link } from "react-router-dom";
import RingLoader from "react-spinners/RingLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { Comment, Done, ExpandMore, Visibility } from "@material-ui/icons";
import audience from "../../icons/audience.png";
import criticFilterPref from "../../config/criticFilterPref";
import black from "../../black.jpg";
import { push as Menu } from "react-burger-menu";
import { useMediaQuery } from "react-responsive";
import Genre from "../Genre/Genre";
import CriticNav from "../CriticNav/CriticNav";
import { getInfo } from "../../utils/hooks";
import Dropdown from "../Main/Dropdown/Dropdown";
import Welcome from "../Welcome/Welcome";
import ReactGA from "react-ga";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

type Filter = {
    name: string;
    value: string;
    icon: string;
};

type FilterState = {
    genres: string[];
    status: string[];
    languages: string[];
};

const CriticMain: React.FC = () => {
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    function closeDropdowns(event: any) {
        if (
            !event.target.matches(".dropbtn") &&
            !event.target.matches(".dropdown-content") &&
            !event.target.matches(".filter__check") &&
            !event.target.matches(".check__container") &&
            !event.target.matches(".checkmark")
        ) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) {
                    openDropdown.classList.remove("show");
                }
            }
        }
    }

    useEffect(() => {
        fetch(
            config.BASE_URL + "/idam/get/static/critic_filter_preferences.json"
        )
            .then((response) => response.json())
            .then((resp) => {
                setFilterPrefs({
                    ...resp.data,
                });
            });

        window.addEventListener("click", closeDropdowns);
        return () => window.removeEventListener("click", closeDropdowns);
    }, []);

    const article_tag = useQuery().get("article_tag");
    const entity = useQuery().get("entity");
    const person_entity = useQuery().get("person_entity");
    const [token, setToken] = useState("");
    const [filterPrefs, setFilterPrefs] = useState(criticFilterPref);

    const [hasTimeline, setHasTimeline] = useState(false);
    const [currentFilter, setCurrentFilter] = useState<FilterState>({
        genres: [],
        status: [],
        languages: [],
    });
    const [storyList, setStoryList] = useState<{ [key: string]: any }[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [currCount, setCurrCount] = useState(1);
    const [relevenaceScore, setrelevenaceScore] = useState("desc");

    function handleShowMore(e: any) {
        e.preventDefault();
        setCurrCount(currCount + 1);
    }

    function handleRelevenace(e: any) {
        setrelevenaceScore(e.target.value);
    }

    useEffect(() => {
        const formData = new FormData();
        const filterJson = {
            genre: currentFilter.genres.toString(),
            status: currentFilter.status.toString(),
            language: currentFilter.languages.toString(),
        };

        formData.append("filters", JSON.stringify(filterJson));
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        formData.append("order", "relevenace_score:" + relevenaceScore);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL +
                "/v1/get/showmilers/feed?" +
                "climit=" +
                32 +
                "&page=" +
                currCount,
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                if (resp.data.length < 32) {
                    setCanLoadMore(false);
                }
                if (currCount === 1) {
                    setStoryList(resp.data);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify(resp.data)
                    );
                } else {
                    setStoryList([...storyList, ...resp.data]);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify([...storyList, ...resp.data])
                    );
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
        // console.log(filterJson);
    }, [currentFilter, currCount, relevenaceScore]);

    function handleChange(e: any, name: string, value: string, arr: string[]) {
        e.stopPropagation();
        ReactGA.event({
            category: "Critic Home",
            action: "Filter applied on " + name,
            label: value,
        });

        if (name === "timeline") {
            setHasTimeline(!hasTimeline);
            setCurrentFilter({ ...currentFilter });
            return;
        }
        setCurrCount(1);
        setCanLoadMore(true);
        if (!arr) arr = [];
        var ind = -1;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === value) {
                ind = i;
                break;
            }
        }
        if (ind != -1) {
            arr.splice(ind, 1);
        } else {
            arr.push(value);
        }
        setCurrentFilter({ ...currentFilter });
        console.log(currentFilter);
    }

    function handleNoImage(e: any) {
        e.target.src = black;
    }

    function resetAllFilters() {
        const data = {
            genres: [],
            status: [],
            languages: [],
        };
        Cookies.set("current_filter", JSON.stringify(data));
        setCurrentFilter({ ...data });
        setCurrCount(1);
        setCanLoadMore(true);
    }

    return (
        <React.Fragment>
            <Welcome
                title="The wait is over. Time to read some interesting stories. Start giving Feedback."
                body="Stories are available on Crime and Thriller genre. More genre to be added soon!"
            />
            <Genre />
            <div id="outer-container">
                <CriticNav />
                <div
                    className="main__content"
                    id="main"
                    style={{ marginTop: "0" }}
                >
                    <div>
                        <h2
                            className="big__heading"
                            style={{ marginLeft: "auto", marginTop: "115px" }}
                        >
                            Hi {getInfo()?.name ?? "User"}, Check these stories
                            from our writer community!
                        </h2>
                    </div>
                    <div
                        className="filter__dropdowns"
                        style={{ justifyContent: "center" }}
                    >
                        <Dropdown
                            title="Genre"
                            filterApplied={currentFilter.genres.length !== 0}
                            styles={{ margin: "12px 0" }}
                            contentStyles={{
                                maxHeight: "300px",
                                overflowY: "auto",
                            }}
                        >
                            <div>
                                {filterPrefs.genres?.map((genre) => {
                                    return (
                                        <label
                                            className={
                                                currentFilter.genres.includes(
                                                    genre.value
                                                )
                                                    ? "check__container selected"
                                                    : "check__container"
                                            }
                                            onClick={(e) =>
                                                handleChange(
                                                    e,
                                                    "genre",
                                                    genre.value,
                                                    currentFilter.genres
                                                )
                                            }
                                        >
                                            <div>{genre.name}</div>
                                            {currentFilter.genres.includes(
                                                genre.value
                                            ) && <Done className="green_dot" />}
                                        </label>
                                    );
                                })}
                            </div>
                        </Dropdown>
                        <Dropdown
                            title="Status"
                            filterApplied={currentFilter.status.length !== 0}
                            styles={{ margin: "12px 0" }}
                        >
                            {filterPrefs.status?.map((st) => {
                                return (
                                    <label
                                        className={
                                            currentFilter.status.includes(
                                                st.value
                                            )
                                                ? "check__container selected"
                                                : "check__container"
                                        }
                                        onClick={(e) =>
                                            handleChange(
                                                e,
                                                "status",
                                                st.value,
                                                currentFilter.status
                                            )
                                        }
                                    >
                                        <div>{st.name}</div>
                                        {currentFilter.status.includes(
                                            st.value
                                        ) && <Done className="green_dot" />}
                                    </label>
                                );
                            })}
                        </Dropdown>
                        <Dropdown
                            title={"Language"}
                            filterApplied={currentFilter.languages.length !== 0}
                            styles={{ margin: "12px 0" }}
                            contentStyles={{
                                maxHeight: "300px",
                                overflowY: "auto",
                            }}
                        >
                            {filterPrefs.languages?.map((language) => {
                                return (
                                    <label
                                        className={
                                            currentFilter.languages.includes(
                                                language.value
                                            )
                                                ? "check__container selected"
                                                : "check__container"
                                        }
                                        onClick={(e) =>
                                            handleChange(
                                                e,
                                                "language",
                                                language.value,
                                                currentFilter.languages
                                            )
                                        }
                                    >
                                        <div>{language.name}</div>
                                        {currentFilter.languages.includes(
                                            language.value
                                        ) && <Done className="green_dot" />}
                                    </label>
                                );
                            })}
                        </Dropdown>
                        <button className="seco__btn" onClick={resetAllFilters}>
                            Reset All
                        </button>
                    </div>
                    <div className="main__list">
                        <div style={{ margin: "0 140px" }}>
                            {isLoading && currCount === 1 ? (
                                <RingLoader
                                    color="rgb(81,35,67)"
                                    loading={isLoading}
                                />
                            ) : (
                                <div className="story__sec">
                                    {storyList.length === 0 ? (
                                        <p>No Stories Found.</p>
                                    ) : (
                                        storyList.map((story: any) => {
                                            return (
                                                <Link
                                                    to={`/critic/read/${story.id}`}
                                                    className="story__title"
                                                >
                                                    <div className="story__box">
                                                        <div className="story__right">
                                                            {/* <Link className="story__add" to={`/story/${story.id}`} style={{borderLeft: "5px solid #c3e36a", borderRight:"0", borderTop:"0", borderBottom:"0", borderRadius: "0", transition: 'all 0.5s ease'}}>Read more</Link> */}
                                                        </div>
                                                        <div className="story__left">
                                                            {story.cover_image !==
                                                            "" ? (
                                                                <img
                                                                    src={
                                                                        story.cover_image
                                                                    }
                                                                    style={{
                                                                        objectFit:
                                                                            "cover",
                                                                    }}
                                                                    onError={
                                                                        handleNoImage
                                                                    }
                                                                    className="story__banner"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={black}
                                                                    style={{
                                                                        objectFit:
                                                                            "cover",
                                                                    }}
                                                                    className="story__banner"
                                                                />
                                                            )}

                                                            <div className="gradient__back">
                                                                <h5 className="small__header">
                                                                    {story.title
                                                                        .length >
                                                                    80
                                                                        ? story.title.substr(
                                                                              0,
                                                                              80
                                                                          ) +
                                                                          "....."
                                                                        : story.title}
                                                                </h5>
                                                                {/* <div className="info">
                                                                    <div className="shadow__text__inline">
                                                                        <Visibility
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                            }}
                                                                        />
                                                                        <p
                                                                            style={{
                                                                                margin: "0 0 0 5px",
                                                                                textShadow:
                                                                                    "0 0px 10px black",
                                                                            }}
                                                                        >
                                                                            {
                                                                                story.number_of_views
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <div className="shadow__text__inline">
                                                                        <Comment
                                                                            style={{
                                                                                fontSize:
                                                                                    "12px",
                                                                            }}
                                                                        />
                                                                        <p
                                                                            style={{
                                                                                margin: "0 0 0 5px",
                                                                                textShadow:
                                                                                    "0 0px 10px black",
                                                                            }}
                                                                        >
                                                                            {
                                                                                story.number_of_comments
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                            {!isLoading && canLoadMore && (
                                <div
                                    style={{
                                        textAlign: "center",
                                        marginTop: "20px",
                                    }}
                                >
                                    <button
                                        onClick={handleShowMore}
                                        className="borderless__btn"
                                        style={{ margin: "auto" }}
                                    >
                                        Show More <ExpandMore />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CriticMain;
